import { useState } from "react";
import { IMaskInput } from "react-imask";

interface IProps {
  onChange?: Function;
  onBlur?: Function,
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  className?: string;
  formatAs: string;
  customFormatSuffix?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  title?: string;
}

let maskMap = new Map<string, any>();
maskMap.set("rsd",
  [
    { mask: '' },
    {
      mask: 'num rsd',
      lazy: false,
      blocks: {
        num: {
          mask: Number,
          scale: 2,
          thousandsSeparator: '.',
        }
      }
    }]
);
maskMap.set("money",
  [
    { mask: '' },
    {
      mask: 'num',
      lazy: false,
      blocks: {
        num: {
          mask: Number,
          scale: 2,
          padFractionalZeros: true,
          thousandsSeparator: '.',
        }
      }
    }]
);
maskMap.set("quantity",
  [
    { mask: '' },
    {
      mask: 'num',
      lazy: false,
      blocks: {
        num: {
          mask: Number,
          scale: 2,
          thousandsSeparator: '.',
        }
      }
    }]
);

const getCustomFormat = (suffix: string) => {
  return [
    { mask: '' },
    {
      mask: 'num ' + suffix,
      lazy: false,
      blocks: {
        num: {
          mask: Number,
          scale: 2,
          thousandsSeparator: '.',
        }
      }
    }]
}

const NumberInput = ({ onChange, onBlur, value, defaultValue, placeholder, className, formatAs, customFormatSuffix, disabled, autoFocus, title }: IProps) => {

  const mask = formatAs === 'custom'
    ? getCustomFormat(customFormatSuffix !== undefined ? customFormatSuffix : '')
    : maskMap.get(formatAs);
  const [temporaryUnmaskedValue, setTemporaryUnmaskedValue] = useState<string | undefined>(undefined);
  const [temporaryValue, setTemporaryValue] = useState<string | undefined>(undefined);
  const valueFormatted = value !== undefined && value !== null
    ? (temporaryUnmaskedValue !== undefined && Number(temporaryUnmaskedValue) === Number(value) ? temporaryValue : value.replace(".", ","))
    : value;
  const defaultValueFormatted = defaultValue !== undefined && defaultValue !== null ? defaultValue.toString().replace(".", ",") : defaultValue;

  return (
    <IMaskInput
      onAccept={(value, mask) => {
        setTemporaryUnmaskedValue(mask.unmaskedValue);
        setTemporaryValue(value);
        if (onChange !== undefined) {
          const parsedValue = mask.unmaskedValue.length === 0 ? null : Number(mask.unmaskedValue)
          onChange(value, mask.unmaskedValue, parsedValue);
        }
      }}
      title={title}
      onBlur={(e) => {
        if (onBlur) {
          if (e.target.value) {
            onBlur(Number(e.target.value.replace(".", "").replace(",", ".")));
          } else {
            onBlur(null);
          }
        }
      }}
      mask={mask}
      radix=","
      value={valueFormatted}
      defaultValue={defaultValueFormatted}
      placeholder={placeholder}
      className={className}
      disabled={disabled !== undefined ? disabled : false}
      autoFocus={autoFocus}
    />
  );
};

export default NumberInput;
